import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserProfileSelector } from '../state/user-profile.selector';


export interface ProfileValidationResult {
  isValid: boolean;
  missingFields: string[];
}

@Injectable({
  providedIn: 'root'
})
export class UserProfileValidator {
  
  constructor(protected readonly store: Store) {}

  validateProfileCompletion(): ProfileValidationResult {
    const isComplete = this.store.selectSnapshot(
      UserProfileSelector.isProfileComplete
    );
    
    if (isComplete) {
      return { 
        isValid: true, 
        missingFields: [] 
      };
    }
    
    const missingFields = this.store.selectSnapshot(
      UserProfileSelector.missingProfileFields
    );
    
    return { 
      isValid: false, 
      missingFields 
    };
  }
}

